export const common = {
  nav: {
    home: 'Home',
    services: 'Services',
    about: 'About',
    history: 'History',
    contact: 'Contact'
  },
  hero: {
    title: 'Certification and Technical Consulting with',
    titleHighlight: 'Excellence',
    description: 'Complete technical support to certify your products with agility and confidence. Specialists in INMETRO, ANATEL, ANVISA and manufacturer registration.',
    ctaPrimary: 'Request Consultation',
    ctaSecondary: 'Our Services',
    yearsExperience: 'Years of Experience',
    compliance: 'Compliance'
  },
  services: {
    title: 'Our Services',
    subtitle: 'Complete solutions in certification and technical consulting to ensure your products compliance',
    inmetro: {
      title: 'INMETRO Certification',
      description: 'Complete product certification with INMETRO, including energy efficiency, safety and quality. Follow-up of the entire conformity assessment process with specialized technical expertise.'
    },
    anatel: {
      title: 'ANATEL Homologation',
      description: 'Homologation of telecommunications equipment before ANATEL. Complete consulting for products that use radio frequency, ensuring compliance with Brazilian technical standards.'
    },
    anvisa: {
      title: 'ANVISA Registration',
      description: 'Product registration with ANVISA, including medical equipment, cosmetics and health products. Specialized technical support in sanitary regulation and technical documentation.'
    },
    suppliers: {
      title: 'Supplier Registration',
      description: 'Complete consulting for manufacturer registration with regulatory agencies. Preparation of technical documentation, adequacy of production processes and audit follow-up.'
    },
    testing: {
      title: 'Testing Follow-up',
      description: 'Technical follow-up of tests and trials in accredited laboratories. Report analysis, identification of non-conformities and guidance for necessary adjustments.'
    },
    consulting: {
      title: 'Specialized Consulting',
      description: 'Technical consulting in conformity assessment, energy efficiency and technical standards. Strategic support for product adequacy to Brazilian regulatory requirements.'
    }
  },
  about: {
    title: 'About APL Consulting',
    description1: 'APL Consulting and Technical Advisory is focused on providing complete technical support for clients who aim to certify their products with agility and confidence.',
    description2: 'With over 19 years of experience in technical and regulatory certifications, we offer specialized support in INMETRO, ANATEL, ANVISA and manufacturer registration.',
    description3: 'Our expertise ranges from test and trial follow-up to specialized consulting in conformity assessment, ensuring that your products meet all Brazilian regulatory requirements.',
    yearsExperience: 'Years of Experience',
    complianceGuaranteed: 'Guaranteed Compliance',
    badge: 'Specialist in Certification and Conformity Assessment'
  },
  experience: {
    title: 'Professional Background',
    subtitle: 'Since 2005, dedicated to technical and regulatory certifications',
    timeline: [
      {
        period: '2005 - 2016',
        title: 'Technical Manager at INMETRO',
        description: 'Technical manager in conformity assessment programs at the Conformity Assessment Directorate – DConf – at INMETRO.'
      },
      {
        period: '2009 - 2016',
        title: 'Technical Committee Coordinator',
        description: 'Coordinator of the Technical Committee on Energy Efficiency of Electric Motors, Centrifugal Pumps, Lighting, Air Conditioners, Microwaves, Televisions, Fans, Distribution Transformers and Refrigerators.'
      },
      {
        period: '2009 - 2016',
        title: 'Technical Coordinator for Home Appliances',
        description: 'Coordinator of the Technical Committee on Home Appliances and Similar, ensuring quality and safety standards.'
      },
      {
        period: '2009 - 2016',
        title: 'Technical Coordinator of CGIEE - MME',
        description: 'Technical Coordinator of the Home Appliances Technical Committee of the Management Committee for Energy Efficiency Indicators and Levels – CGIEE – Ministry of Mines and Energy – MME.'
      },
      {
        period: '2009 - 2016',
        title: 'Brazilian Technical Coordinator at COPANT',
        description: 'Brazilian Technical Coordinator at the Pan American Standards Commission – COPANT, representing Brazil in international standardization.'
      },
      {
        period: '2018 - 2019',
        title: 'Executive Coordinator and Deputy Director',
        description: 'Coordinator of the Executive and Management Coordination of DConf – CEXEC – and Deputy Director of DConf at INMETRO.'
      },
      {
        period: '2009 - Present',
        title: 'Specialist and Lead Auditor CGCRE',
        description: 'External specialist of the General Coordination of Accreditation – CGCRE – at INMETRO and Lead Auditor in electrical area audits.'
      }
    ]
  },
  contact: {
    title: 'Get in Touch',
    subtitle: 'Request specialized consulting and discover how we can help certify your products',
    phone: 'Phone',
    email: 'Email',
    hours: 'Business Hours',
    hoursValue: 'Monday to Friday: 9am to 6pm',
    whyChoose: 'Why choose APL?',
    reasons: [
      'Over 19 years of experience in certifications',
      'Former INMETRO technical coordinator',
      'Lead auditor in electrical area audits',
      'Complete and personalized consulting'
    ],
    formTitle: 'Request a Consultation',
    formName: 'Full Name',
    formEmail: 'Email',
    formPhone: 'Phone',
    formCompany: 'Company',
    formService: 'Service of Interest',
    formMessage: 'Message',
    formNamePlaceholder: 'Your full name',
    formEmailPlaceholder: 'your@email.com',
    formPhonePlaceholder: '(00) 00000-0000',
    formCompanyPlaceholder: 'Your company name',
    formServicePlaceholder: 'Select a service',
    formMessagePlaceholder: 'Describe your certification needs... (maximum 500 characters)',
    formMaxChars: 'Maximum 500 characters',
    formSubmit: 'Submit Request',
    formSubmitting: 'Sending...',
    formSuccess: 'Message sent successfully! We will contact you soon.',
    formError: 'Error sending message. Please try again.'
  },
  footer: {
    description: 'Certification and technical consulting with excellence since 2005.',
    servicesTitle: 'Services',
    contactTitle: 'Contact',
    hoursTitle: 'Hours',
    hoursValue: 'Monday to Friday\n9am to 6pm',
    copyright: '© 2024 APL Consulting and Technical Advisory Ltd. All rights reserved.',
    poweredBy: 'Powered by Readdy'
  }
};
